import type { Actions, State } from '../state'
import type { Dispatch } from 'react'
import { createContext } from 'react'

type TReferralsContext = [
  state: State,
  dispatch: Dispatch<Actions | Promise<Actions>>,
]

export const ReferralsContext = createContext<TReferralsContext | undefined>(
  undefined,
)
